<template>
  <el-tabs v-model="tabName" tab-position="left">
    <el-tab-pane label="基本信息" name="base">
      <base-info :pId="pId" :envList="envList" @getProjectList="getProjectList" @close="close"></base-info>
    </el-tab-pane>
    <el-tab-pane label="权限管理" name="power">
      <permission-management :pId="pId" :envList="envList" @getProjectList="getProjectList"></permission-management>
    </el-tab-pane>
  </el-tabs>

</template>
<script>
import BaseInfo from './baseInfo.vue';
import PermissionManagement from './rbca.vue';
export default {
  props: {
    tName: {
      type: String,
      default: 'base'
    },
    pId: {
      type: String,
      default: ''
    },
    envList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    tabName: {
      get () {
        return this.tName;
      },
      set (val) {
        this.$emit('update:tName', val);
      }
    }
  },
  components: {
    BaseInfo,
    PermissionManagement,
  },
  methods: {
    getProjectList () {
      this.$emit('getProjectList');
    },
    close () {
      this.$emit('close');
    }
  }
}
</script>

